// Canonical MIME strings for document/tabular file types, shared by the upload allowlists
// (document uploads, Rex attachments, safety imports) so the lists can't drift apart.
export const PDF_MIME = "application/pdf";
export const DOC_MIME = "application/msword";
export const DOCX_MIME = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const XLS_MIME = "application/vnd.ms-excel";
export const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const CSV_MIME = "text/csv";

export const EXCEL_MIMES = [XLSX_MIME, XLS_MIME] as const;
export const EXCEL_MIME_SET: ReadonlySet<string> = new Set(EXCEL_MIMES);

// Shared by the dashboard job-photo upload allowlist and the backend GET /jobs/:id/images filter.
export const JOB_PHOTO_UPLOAD_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/heic"] as const;
export const JOB_PHOTO_UPLOAD_MIME_TYPE_SET: ReadonlySet<string> = new Set(JOB_PHOTO_UPLOAD_MIME_TYPES);

// Wider than the upload allowlist: timesheet/daily report attachments can be any mobile image format.
export const JOB_PHOTO_IMAGE_MIME_TYPES = [
  ...JOB_PHOTO_UPLOAD_MIME_TYPES,
  "image/webp",
  "image/gif",
  "image/heif",
] as const;
